import { createSsrRequestContext, type SsrRequestContext } from '@repo/ssr'
import {
	createCsrfMiddleware,
	createMiddleware,
	createStart
} from '@tanstack/react-start'

declare module '@tanstack/react-router' {
	interface Register {
		server: {
			requestContext: SsrRequestContext
		}
	}
}

const csrfMiddleware = createCsrfMiddleware({
	filter: (ctx) => ctx.handlerType === 'serverFn'
})

const ssrRequestContextMiddleware = createMiddleware().server(
	async ({ request, next }) =>
		next({
			context: createSsrRequestContext(request)
		})
)

export const startInstance = createStart(() => ({
	defaultSsr: import.meta.env.MODE === 'ssr-all',
	requestMiddleware: [csrfMiddleware, ssrRequestContextMiddleware]
}))
